import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import UserContainer from 'components/user/container/UserContainer';
import Table from 'components/table/Table';
import { formatDate } from 'controls/utils';
import { Language } from 'language/Language';
import 'components/table/_Table.scss';
import { ordersStrings } from './strings';

const Orders = () => {
  const { orders } = useSelector((state) => state);
  const language = Language();
  const headers = [ordersStrings[language].order, ordersStrings[language].date, ordersStrings[language].status, ordersStrings[language].total, ordersStrings[language].actions];

  return (
    <UserContainer>
      <Table>
        <>
          <Table.Header headers={headers} />
          <Table.Content>
            <>
              {orders
                ? (
                  orders.map((order) => (
                    <div className='table-row' key={order.orderID}>
                      <div className='table-content__item order-table__item'>
                        <Link to={`${language === 'japan' ? `/jp/私のアカウント/view-order?${order.orderID}` : `/my-account/view-order?${order.orderID}`}`}>
                          {`#${order.orderID}`}
                        </Link>
                      </div>
                      <div className='table-content__item order-table__item'>
                        <p>{formatDate(order.createdAt)}</p>
                      </div>
                      <div className='table-content__item order-table__item'>
                        <p>{order.status}</p>
                      </div>
                      <div className='table-content__item order-table__item'>
                        <p>{`${order.currency || '$'} ${order.total}`}</p>
                      </div>
                      <div className='table-content__item' style={{ maxHeight: '7rem' }}>
                        <Link
                          to={`${language === 'japan' ? `/jp/私のアカウント/view-order?${order.orderID}` : `/my-account/view-order?${order.orderID}`}`}
                          className={`table-content__link ${(order.status === 'Cancelled') && 'table-content__disableLink'}`}
                        >
                          {ordersStrings[language].view}
                        </Link>
                      </div>
                    </div>
                  )))
                : (
                  <p style={{ marginTop: '1rem' }}>No order has been made yet.</p>
                )}
            </>
          </Table.Content>
        </>
      </Table>
    </UserContainer>
  );
};

export default Orders;
